var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('header', {
    staticClass: "outstanding-header",
    class: {
      noMenu: !_vm.isMarketOpen
    },
    attrs: {
      "role": "banner"
    }
  }, [_c('Banner', _vm._b({
    attrs: {
      "is-scramble-link": _vm.isCurrentRouteNeedsScrambleLinksForHeader
    }
  }, 'Banner', _vm.urls, false)), _vm._v(" "), _c('BannerMobile', _vm._b({
    ref: "bannerMobile",
    attrs: {
      "is-scramble-link": _vm.isCurrentRouteNeedsScrambleLinksForHeader
    },
    on: {
      "open-layer": function openLayer($event) {
        return _vm.openMenu('mobile');
      }
    }
  }, 'BannerMobile', _vm.urls, false)), _vm._v(" "), _vm.navigation && _vm.isMarketOpen ? _c('transition', {
    attrs: {
      "name": "slide-fade",
      "css": _vm.enableNavTransition
    }
  }, [_vm.displayNavBar && _vm.navigationFiltered ? _c('NavigationBar', {
    ref: "navigationBar",
    staticClass: "nav-bar",
    attrs: {
      "hash-first-cat": _vm.hashFirstCat,
      "navigation": _vm.navigationFiltered,
      "services": _vm.navigationServices,
      "opened-menu": _vm.isMenuOpened
    },
    on: {
      "select-item": _vm.openMenu
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.navigationFiltered && _vm.isMarketOpen ? _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('LayerFullscreenHeader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isMenuOpened,
      expression: "isMenuOpened"
    }],
    ref: "layerFullscreen",
    staticClass: "layer",
    on: {
      "close-menu": function closeMenu($event) {
        return _vm.closeMenu();
      }
    }
  }, [_c('LayerMobile', _vm._b({
    ref: "layerMobile",
    staticClass: "d-lg-none",
    attrs: {
      "navigation": _vm.navigationFiltered,
      "services": _vm.navigationServices
    },
    on: {
      "close-menu": function closeMenu($event) {
        return _vm.closeMenu();
      }
    }
  }, 'LayerMobile', _vm.urls, false)), _vm._v(" "), _vm.isMenuOpened && _vm.isDesktop() && _vm.selectedItem ? _c('LayerDesktop', _vm._b({}, 'LayerDesktop', _vm.selectedItem, false)) : _vm._e()], 1)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };